import { FieldValues } from "react-hook-form";
import {
  Modal,
  ModalClose,
  ModalContent,
  ModalHead,
  ModalWrapper,
} from "@songtradr-one/components-frontend";
import { Form } from "../form/Form";
import { FormSubmissionData } from "../form/Form.Parts";
import {
  DEFAULT_WIDTH,
  Props,
  focusFirstInput,
  text,
} from "./FormDialog.Parts";

export const FormDialog = <T extends FieldValues>({
  open,
  onOpenChange,
  title,
  description,
  submitButtonText = text.submit,
  cancelButtonText = text.cancel,
  fields,
  sections,
  defaultValues,
  layout,
  width = DEFAULT_WIDTH,
  disableWhenInvalid = false,
  onSubmit,
  onCancel,
}: Props<T>) => {
  const handleSubmit = async (data: FormSubmissionData<T>) => {
    const success = await onSubmit(data);
    if (success !== false) {
      onOpenChange(false);
    }
  };

  const handleCancel = () => {
    onCancel?.();
    onOpenChange(false);
  };

  return (
    <Modal open={open} onOpenChange={onOpenChange}>
      <ModalWrapper $width={width} onOpenAutoFocus={focusFirstInput}>
        <ModalClose />
        <ModalHead title={title ?? ""} description={description} />
        <ModalContent>
          <Form
            defaultValues={defaultValues}
            fields={fields}
            sections={sections}
            onSubmit={handleSubmit}
            layout={{
              columns: 1,
              gap: "1rem",
              ...layout,
            }}
            cancelButton={{
              text: cancelButtonText,
              onClick: handleCancel,
              variant: "subtle",
              size: "normal",
            }}
            submitButton={{
              text: submitButtonText,
              variant: "primary",
              size: "normal",
              disableWhenUnchanged: false,
              disableWhenInvalid,
            }}
          />
        </ModalContent>
      </ModalWrapper>
    </Modal>
  );
};
